import imagesLoaded from "imagesloaded"
import lightGallery from "lightgallery"
import lgThumbnail from "lightgallery/plugins/thumbnail"

const licenseKey = "C789E420-34844F09-94EB07AB-DE2E7417"
const lightGalleryInstances = new WeakMap()
const masonryInstances = new WeakMap()
const dynamicGalleryButtons = new WeakSet()
const masonryControls = new WeakSet()
const masonryRetryTimers = new WeakMap()
const masonryRetryDelay = 100

function initialiseLightGallery(container) {
  const setLightGallery = (galleryElement) => {
    const existingLightGallery = lightGalleryInstances.get(galleryElement)

    if (existingLightGallery) {
      existingLightGallery.destroy()
    }

    const lightGalleryPlugin = lightGallery(galleryElement, {
      plugins: [],
      speed: 500,
      licenseKey: licenseKey,
      zoomFromOrigin: true,
      selector: "a.gallery-image",
    })

    lightGalleryInstances.set(galleryElement, lightGalleryPlugin)

    return lightGalleryPlugin
  }

  const galleryElements = container.querySelectorAll(".gallery-images-js")

  if (!galleryElements.length) {
    return
  }

  galleryElements.forEach((galleryElement) => {
    setLightGallery(galleryElement)
  })
}

function initialiseDynamicLightGallery() {
  document.querySelectorAll(".thumbnail-gallery").forEach(function (card) {
    const galleryButton = card.querySelector(".gallery-cta")
    const dynamicElements = []

    if (galleryButton && !dynamicGalleryButtons.has(galleryButton)) {
      dynamicGalleryButtons.add(galleryButton)

      card.querySelectorAll(".card-image").forEach(function (image) {
        dynamicElements.push({
          src: image.dataset.src,
          thumb: image.dataset.src,
          subHtml: image.dataset.description,
        })
      })

      if (dynamicElements.length > 0) {
        const dynamicGallery = lightGallery(galleryButton, {
          licenseKey: licenseKey,
          plugins: [lgThumbnail],
          dynamic: true,
          dynamicEl: dynamicElements,
          thumbnail: true,
        })

        galleryButton.addEventListener("click", function (event) {
          event.preventDefault()
          dynamicGallery.openGallery()
        })
      }
    }
  })
}

function initialiseMasonry(container) {
  const masonryGrids = container.querySelectorAll(".masonry-grid")
  const filterButtons = container.querySelectorAll(".filter-buttons > button")
  const selects = container.querySelectorAll(".filter-select")

  if (!masonryGrids.length) {
    return
  }

  const scheduleMasonryRetry = () => {
    if (masonryRetryTimers.has(container)) {
      return
    }

    const retryTimer = window.setTimeout(() => {
      masonryRetryTimers.delete(container)
      initialiseMasonry(container)
    }, masonryRetryDelay)

    masonryRetryTimers.set(container, retryTimer)
  }

  const watchFilterButtons = () => {
    if (masonryControls.has(container)) {
      return
    }

    masonryControls.add(container)

    filterButtons.forEach((filterButton) => {
      filterButton.addEventListener("click", (e) => {
        initialiseMasonry(container)
      })
    })

    selects.forEach((select) => {
      select.addEventListener("change", (e) => {
        initialiseMasonry(container)
      })
    })
  }

  watchFilterButtons()

  const MasonryConstructor = window.Masonry

  if (typeof MasonryConstructor !== "function") {
    scheduleMasonryRetry()
    return
  }

  const reinitialiseMasonry = (masonryGrid) => {
    const existingMasonry = masonryInstances.get(masonryGrid)

    if (existingMasonry) {
      existingMasonry.destroy()
    }

    const masonry = new MasonryConstructor(masonryGrid, {
      itemSelector: ".gallery-image",
    })

    masonry.reloadItems()

    masonryInstances.set(masonryGrid, masonry)

    return masonry
  }

  masonryGrids.forEach((masonryGrid) => {
    reinitialiseMasonry(masonryGrid)
  })
}

function initialiseBespokeGalleries() {
  document.querySelectorAll(".gallery-container-bespoke").forEach((container) => {
    const loadingSpinner = container.querySelector("#loading-spinner")

    initialiseLightGallery(container)

    imagesLoaded(container, function (instance) {
      initialiseMasonry(container)

      if (loadingSpinner) {
        loadingSpinner.style.display = "none"
      }
    })
  })

  initialiseDynamicLightGallery()
}

function initialiseWhenReady() {
  initialiseBespokeGalleries()
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initialiseWhenReady)
} else {
  initialiseWhenReady()
}

document.addEventListener("livewire:navigated", (event) => {
  initialiseBespokeGalleries()
})
